/**
 * @component {"type":"DiplomaButton","version":"1.1"}
 */

define('component-diploma',['knockout', 'helpers'], function(ko, helpers) {

    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,

            // Count user hour offset
            d = new Date(),
            off = d.getTimezoneOffset(),
            hourOff = Math.abs(off / 60),
            diplomaUrlStr = dataContext.diplomaURL + '?hourOffset=' + hourOff;

        self.content = ko.computed(function() {
            return helpers.component.getContent(entityVM.componentsJSON(), 'DiplomaButton');
        });

        self.url = ko.computed(function() {
            var obj = {},
                arr = helpers.component.parseProp(self.content(), 'items', 'DiplomaText');

            if (!arr.length) {
                return diplomaUrlStr;
            }

            for (var i = 0; i < arr.length; i++) {
                if (arr[i] && arr[i].id && arr[i].text) {
                    obj[arr[i].id] = helpers.misc.replaceTextholder(parentVM.training, parentVM.user, arr[i].text).replace(/<[^>]+>/g, '');
                }
            }

            if (Object.keys(obj).length) diplomaUrlStr += '&customTexts=' + encodeURIComponent(JSON.stringify(obj));
            return diplomaUrlStr;
        });


        self.label = ko.computed(function() {
            var content = self.content();

            return (content && content.buttonLabel) ? content.buttonLabel : '';
        });
    };

});

